<template>
    <div>
        <ul class="loan-category__list">
            <li 
                v-for="(lender, index) in config.lenders" 
                :key="index"
                class="loan-category__list-item"
            >
                <OptionalLink class="loan-category__list-item-box" :href="lender.link">
                    <div class="box-header-wrapper">
                        <div class="box-header">
                            <span class="company-name">{{ lender.name }}</span>
                            <span class="loan-type"> {{ config.title }}</span>
                        </div>
                        <PrismicImage
                            v-if="lender.logoData.logo.url"
                            :img="lender.logoData.logo"
                            class="lender-logo"
                            :w="lender.logoData.width"
                            :h="lender.logoData.height"
                        />
                    </div>
                    <div 
                        v-if="lender.highlightedItems.length" 
                        class="highlighted-items-wrapper"
                    >
                        <div 
                            v-for="(item, itemIndex) in lender.highlightedItems"
                            :key="`highlighted-items-${itemIndex}`"    
                            class="highlighted-items"
                        >
                            <div class="highlighted-label">
                                {{ item.label }}
                            </div>
                            
                            <div 
                                class="highlighted-value" 
                                v-html="item.value" 
                            />
                        </div>
                    </div>

                    <div 
                        v-if="lender.popularityTextHtml"
                        class="popularity-text"
                        v-html="lender.popularityTextHtml" 
                    />
                </OptionalLink>
            </li>
        </ul>
        <div 
            v-if="config.generalLink.link"
            class="text-center mt-4"
        >
            <nuxt-link 
                :to="$prismic.linkResolver(config.generalLink.link)"
                class="general-link"    
            >
                <span>
                    {{ config.generalLink.text }}
                </span>
                <i class="fa-solid fa-arrow-right fa-sm" />
            </nuxt-link>
        </div>
    </div>
</template>

<script>
import OptionalLink from '@/components/OptionalLink.vue';

export default {
    components: {
        OptionalLink
    },
    props: {
        config: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
    .loan-category__list {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 1.25rem;
        padding: 0;
        list-style: none;

        @include device(pad) {
            grid-template-columns: repeat(2, 1fr);
        }
        
        @include device(desktop) {
            grid-template-columns: repeat(4, 1fr);
        }
        &-item-box {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            height: 100%;
            background: $white;
            padding: 1rem;
            @include border-radius(3px);
            box-shadow: $bxs;
            text-decoration: none;
            color: inherit;
            transition: transform 0.2s;
            @include border();

            &.is-link:hover {
                transform: translateY(-4px);
            }

            @include device(pad) {
                padding: 1.5rem;
            }

            .box-header-wrapper {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: .5rem;
                @include border(bottom);
                padding-bottom: 0.5rem;
                .box-header {
                    display: flex;
                    flex-direction: column;
                    .company-name {
                        font-family: $fontHeader;
                        font-weight: bold;
                        @include font-size(18px);
                    }
                    
                    .loan-type {
                        @include font-size(14px, 8px);
                        color: #666;
                    }
                }
                .lender-logo {
                    @include border-radius(5px);
                    object-fit: contain;
                }
            }
            .highlighted-items-wrapper {
                display: flex;
                flex-direction: column;
                gap: .75rem;

                .highlighted-items {
                    display: flex;
                    flex-direction: column;
                    gap: .25rem;
                    
                    .highlighted-label {
                        @include font-size(14px, 8px);
                    }
                    .highlighted-value {
                        font-weight: bold;
                        color: $font;
                    }
                }
            }
        }
    }
    .general-link {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: bold;
        color: $blue;
        text-decoration: none;
        &:hover {
            span {
                text-decoration: underline;
            };
        }
    }
</style>